import { useCallback, useEffect, useState } from "react";

import { IconCaretSmallLeft, IconCaretSmallRight } from "@btnet/blueprint-icons";
import { cn } from "@btnet/utilities-core";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";

export interface IJobPickerResizeHandleProps {
    collapsed: boolean;
    drawerOpen: boolean;
    onResize: (dx: number) => void;
    setCollapsed: (isCollapsing: boolean) => void;
}

export const JobPickerResizeHandle: React.FunctionComponent<IJobPickerResizeHandleProps> = (
    props,
) => {
    const { onResize } = props;
    const [dragShield, setDragShield] = useState(false);

    const handleResize = useCallback(
        (e: MouseEvent) => {
            e.stopPropagation();
            e.preventDefault();
            onResize(e.x);
        },
        [onResize],
    );

    const endResize = useCallback(() => {
        globalThis.removeEventListener("mousemove", handleResize);
        setDragShield(false);
    }, [handleResize]);

    useEffect(() => {
        return () => {
            globalThis.removeEventListener("mousemove", handleResize);
        };
    }, [handleResize]);

    useEffect(() => {
        return () => {
            globalThis.removeEventListener("mouseup", endResize);
        };
    }, [endResize]);

    return (
        <div
            className={cn("SidebarResizeHandle", {
                Closed: props.collapsed,
                Drawer: props.drawerOpen,
            })}
            onMouseDown={(e) => {
                if (
                    !props.collapsed &&
                    (e.target as HTMLElement).classList.contains("SidebarResizeHandle")
                ) {
                    e.stopPropagation();
                    e.preventDefault();
                    globalThis.addEventListener("mousemove", handleResize);
                    globalThis.addEventListener("mouseup", endResize);
                    setDragShield(true);
                }
            }}
        >
            <BTButton
                data-testid="sidebarOpenButton"
                className="SidebarOpenButton"
                icon={
                    props.collapsed && !props.drawerOpen ? (
                        <IconCaretSmallRight />
                    ) : (
                        <IconCaretSmallLeft />
                    )
                }
                type="secondary"
                onClick={() => props.setCollapsed(!props.collapsed)}
            />
            {/* This will block other mouse events during drag */}
            {dragShield && <div className="SidebarResizeDragShield" />}
        </div>
    );
};
